// extracted by mini-css-extract-plugin
export var TitleBox = "expertise-module--TitleBox--f5951";
export var expertiseBox = "expertise-module--expertiseBox--de0a8";
export var expertise_listing = "expertise-module--expertise_listing--9f592";
export var expertise_wrap = "expertise-module--expertise_wrap--2f461";
export var icon = "expertise-module--icon--70647";